import MetricModal from './MetricModal';

export default MetricModal;
